import Swiper, { Navigation, Pagination } from 'swiper'

export class CardCarousel {
    constructor(carouselEl: HTMLElement) {
        Swiper.use([Navigation, Pagination]);
        const itemsPerPage = parseInt(carouselEl.getAttribute('data-items-per-page') || '4', 10);
        const nextEl = carouselEl.querySelector('.swiper-button-next') as HTMLElement;
        const prevEl = carouselEl.querySelector('.swiper-button-prev') as HTMLElement;
        const paginationEl = carouselEl.querySelector('.swiper-pagination') as HTMLElement;
        if (!nextEl || !prevEl || !paginationEl) return;

        function getPageStartIndexes(totalSlides: number, slidesPerPage: number): number[] {
            if (totalSlides <= slidesPerPage) return [0];
            const indexes = [];
            let i = 0;
            while (i < totalSlides - slidesPerPage) {
                indexes.push(i);
                i += slidesPerPage;
            }
            indexes.push(totalSlides - slidesPerPage);
            return indexes;
        }

        const swiper = new Swiper(carouselEl as HTMLElement, {
            slidesPerView: 1,
            spaceBetween: 32,
            loop: false,
            navigation: {
                nextEl,
                prevEl
            },
            pagination: {
                el: paginationEl,
                type: 'custom',
                clickable: true,
                renderCustom: function (swiper) {
                    const slidesPerView = Math.floor(swiper.params.slidesPerView as number);
                    const totalSlides = swiper.slides.length;
                    const pageIndexes = getPageStartIndexes(totalSlides, slidesPerView);

                    let currentPage = 1;
                    for (let i = 0; i < pageIndexes.length; i++) {
                        if (swiper.activeIndex >= pageIndexes[i]) {
                            currentPage = i + 1;
                        }
                    }
                    let html = '';
                    for (let i = 0; i < pageIndexes.length; i++) {
                        html += `<span class="swiper-pagination-custom-page${i + 1 === currentPage ? ' active' : ''}" data-page="${i + 1}">${i + 1}</span>`;
                    }
                    return html;
                }
            },
            breakpoints: {
                600: {
                    slidesPerView: 2.2
                },
                1024: {
                    slidesPerView: itemsPerPage + 0.5
                }
            }
        });
        swiper.on('breakpoint', function () {
            if (swiper.pagination && typeof swiper.pagination.render === 'function') {
                swiper.pagination.render();
            }
        });
        paginationEl.addEventListener('click', function (e) {
            const target = e.target as HTMLElement;
            if (target.classList.contains('swiper-pagination-custom-page')) {
                const slidesPerView = Math.floor(swiper.params.slidesPerView as number);
                const totalSlides = swiper.slides.length;
                const pageIndexes = getPageStartIndexes(totalSlides, slidesPerView);
                const page = parseInt(target.getAttribute('data-page') || '1', 10);
                const firstIndex = pageIndexes[page - 1];
                swiper.slideTo(firstIndex);

                setTimeout(() => {
                    if (swiper.pagination && typeof swiper.pagination.render === 'function') {
                        swiper.pagination.render();
                    }
                }, 0);
            }
        });
    }
}